/* Recover a published campaign when the app embed's product metadata is missing.
 * The layout includes this only for Customizer products. Verify the storefront
 * campaign and its Shopify variant IDs before enabling the official SDK.
 */
(async () => {
  const campaign = window.teeinblueCampaign;
  const shop = window.Shopify?.shop;
  if (!campaign || campaign.isTeeInBlueProduct || campaign.isPlatformProduct || window.TEEINBLUE_LOADED) return;
  if (!/^\d+$/.test(String(campaign.productId)) || !shop?.endsWith('.myshopify.com')) return;

  const embed = [...document.scripts].find((script) => {
    if (!script.src) return false;
    const url = new URL(script.src);
    return url.origin === 'https://sdk.teeinblue.com' && url.pathname === '/async.js';
  });
  if (!embed) return;
  const embedUrl = new URL(embed.src);
  if (embedUrl.searchParams.get('shop') !== shop || embedUrl.searchParams.get('platform') !== 'shopify') return;
  const version = embedUrl.searchParams.get('v');
  if (!/^\d+$/.test(version || '')) return;
  const sdkUrl = new URL(`/shopify/app-v${version}.js`, embedUrl.origin);
  sdkUrl.searchParams.set('token', embedUrl.searchParams.get('token') || '');
  sdkUrl.searchParams.set('shop', shop);

  try {
    const url = new URL(`https://api.teeinblue.com/api/merchant/campaigns/${campaign.productId}.json`);
    url.searchParams.set('shop', shop);
    url.searchParams.set('v', campaign.version || 1);
    const response = await fetch(url, { signal: AbortSignal.timeout(15000) });
    if (!response.ok) return;
    const data = await response.json();
    const variants = new Set(Object.keys(campaign.variantsById || {}));
    const matchesProduct = data.instance_variants?.some((variant) => variants.has(String(variant.platform_linked_id)));
    if (!data.id || !data.artworks?.length || !matchesProduct || data.has_subscription === false) return;
    if (window.TEEINBLUE_LOADED || campaign.isTeeInBlueProduct) return;

    campaign.isTeeInBlueProduct = true;
    document.dispatchEvent(new Event('gp:personalization-verified'));
    if ([...document.scripts].some((script) => script.src.startsWith(`${sdkUrl.origin}${sdkUrl.pathname}`))) return;
    const script = document.createElement('script');
    script.src = sdkUrl.href;
    script.async = true;
    // The app's async loader checks for a deferred SDK before adding its own.
    script.defer = true;
    document.head.appendChild(script);
  } catch (error) {
    console.warn('Unable to verify the personalization campaign.', error);
  }
})();
